module.exports = __webpack_public_path__ + "static/rock-climbing-bg-23fd495e4a635148ca136c2507581fdf.jpg";